import { Content } from "@/services/content/types";

const groupItemsByDate = (items: Content.Entry[]) => {
  return items.reduce((acc: { [key: string]: Content.Entry[] }, curr) => {
    const date =
      curr.sys.contentType.sys.id === "play" ||
      curr.sys.contentType.sys.id === "play-episode"
        ? (
            (curr as Content.Play).fields.broadcastStart || curr.sys.createdAt
          ).split("T")[0]
        : curr.sys.createdAt.split("T")[0];

    if (acc[date]) {
      acc[date].push(curr);
    } else {
      acc[date] = [curr];
    }

    return acc;
  }, {});
};

export default groupItemsByDate;
